import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core';
import { ClassroomsService, PlatformService } from '@core/services';
import { ChangableComponent } from '@models/changable.component';
import { ErrorNotificationService } from '@shared/error-notification/error-notification.service';
import { Classroom, IFindClassroomsFilter, IPagination, UserService, Router as ContentRouter } from 'lingo2-models';
import { takeUntil, tap } from 'rxjs/operators';

@Component({
  selector: 'app-user-service-debug-classrooms',
  templateUrl: './user-service-debug-classrooms.component.html',
  styleUrls: ['./user-service-debug-classrooms.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserServiceDebugClassroomsComponent extends ChangableComponent {
  @Input()
  public set userService(userService: UserService) {
    const changed = this._userService?.id !== userService?.id;
    this._userService = userService;
    if (changed) {
      this.loadClassrooms(this._userService.id);
    }
  }
  public classrooms: Classroom[] = [];

  private _userService: UserService;

  public constructor(
    public errorNotificationService: ErrorNotificationService,
    private classroomsService: ClassroomsService,
    protected cdr: ChangeDetectorRef,
    protected platform: PlatformService,
  ) {
    super(cdr, platform);
  }

  public classroomRoute(classroom: Classroom): string[] {
    return ContentRouter.classroomRoute(classroom);
  }

  protected loadClassrooms(user_service_id: string) {
    const _filter: Partial<IFindClassroomsFilter> = {
      user_service_id,
    };
    const pagination: IPagination = { page: 1, pageSize: 1000 };
    this.classroomsService
      .getClassrooms(_filter, pagination, ['id', 'title', 'slug'])
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: (response) => {
          this.classrooms = response.results;
          this.detectChanges();
        },
        error: (error) => {
          this.errorNotificationService.captureError(error, 'LOAD-SOMEDATA');
        },
      });
  }

  public trackByFn(index) {
    return index;
  }
}
